<template>
  <div class="container">
    <div class="banner">
      <div class="content">
        <div class="caption">通知要闻</div>
        <p>notice</p>
      </div>
    </div>
    <div class="news-caption">通知要闻</div>
    <div class="content">
      <div class="list-content">
        <List :data="newsList" type="2" />
      </div>

      <div class="pages flex-cc">
        <el-pagination
          :page-size="15"
          :page-sizes="[]"
          @current-change="changePage"
          background
          layout="prev, pager, next"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import List from "@/components/List.vue";
import { getNewsList } from "@/api";
export default {
  name: "Notices",
  components: { List },
  data() {
    return {
      newsList: [],
      noticeType: "",
      total: 0,
    };
  },

  mounted() {
    this.getData();
  },
  methods: {
    changePage(pageNum) {
      this.getData(pageNum);
    },
    getData(pageNum = 1) {
      getNewsList({ noticeType: 2, pageNum, pageSize: 15 }).then((res) => {
        this.newsList = res.rows;
        this.total = res.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  background: #f3f4f8;
  padding-bottom: 72px;
  .banner {
    min-width: 1600px;
    color: #fff;
    height: 510px;
    background: url("../assets/image/details_bg3.jpg");
    background-size: 100% 100%;
    padding-top: 170px;
    .content {
      padding-left: 150px;
    }
    .caption {
      font-size: 46px;
      font-weight: bold;
    }
    p {
      font-size: 12px;
      padding-top: 5px;
    }
  }
  & > .content {
    padding: 25px 56px 70px 30px;
    background: #fff;
    .list-content {
      min-height: 500px;
    }
  }
  .news-caption {
    color: #000;
    text-align: center;
    font-weight: bold;
    font-size: 40px;
    padding-top: 78px;
    margin-bottom: 75px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      width: 70px;
      height: 3px;
      border-radius: 2px;
      background: #1265cc;
      bottom: -22px;
      left: 50%;
      margin-left: -35px;
    }
  }
  .pages {
    padding-top: 68px;
  }
}
</style>
